import { render, staticRenderFns } from "./MalzemeDuzenle.vue?vue&type=template&id=e48c7da4&scoped=true&"
import script from "./MalzemeDuzenle.vue?vue&type=script&lang=js&"
export * from "./MalzemeDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./MalzemeDuzenle.vue?vue&type=style&index=0&id=e48c7da4&scoped=true&lang=css&"
import style1 from "./MalzemeDuzenle.vue?vue&type=style&index=1&id=e48c7da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48c7da4",
  null
  
)

export default component.exports